import React from 'react';
import { StepViewModel } from './types/StepViewModel';
import { Grid, GridItem, Heading, Text } from '@charlietango/ui';
import { FontFamily, TextVariant } from '../../styles/typography';
import { rem } from '../../styles/rem';
import { colors } from '../../styles/colors';
import Image from '../Image/Image';

export type StepsProps = {
  intro?: string;
  className?: string;
  steps?: StepViewModel[];
};

function Steps(props: StepsProps) {
  const { steps = [], intro, className } = props;

  return (
    <section sx={{ my: rem(120) }}>
      {intro && (
        <Heading
          as="h2"
          variant={TextVariant.HeaderXl}
          sx={{
            mb: [6, 7, 8],
            ml: [rem(32), rem(40), rem(40)],
            mr: [rem(32), rem(40), rem(40)],
          }}
        >
          {intro}
        </Heading>
      )}
      <Grid
        className={className}
        gridGap={16}
        gridColumns={12}
        sx={{
          color: colors.base.Text.PrimaryStatic,
          px: [rem(20), rem(20), rem(20)],
        }}
      >
        {steps.map((step, index) => (
          <GridItem
            key={index}
            size={[1, 1 / 3]}
            sx={{
              backgroundColor: colors.components.fixedTop.Background.Default,
              borderRadius: '16px',
            }}
          >
            <div
              sx={{
                px: [rem(20), rem(20), rem(32)],
                pt: rem(20),
                pb: rem(40),
              }}
            >
              <Text
                sx={{
                  fontSize: [rem(52), rem(52), rem(64)],
                  color: colors.base.Text.Brand,
                  fontFamily: FontFamily.Heading,
                }}
              >
                {step.stepNumber}
              </Text>
              {step.image && (
                <Image
                  {...step.image}
                  sizes={['100%']}
                  css={{
                    objectFit: 'cover',
                    objectPosition: 'center',
                    width: '100%',
                    aspectRatio: '1 / 1',
                  }}
                />
              )}
              <Heading
                as={intro ? 'h3' : 'h2'}
                variant={TextVariant.HeaderLg}
                sx={{
                  pt: 5,
                  pb: 4,
                  color: colors.base.Text.PrimaryStatic,
                }}
              >
                {step.title}
              </Heading>
              <Text
                as="p"
                variant={TextVariant.BodyMd}
                sx={{
                  color: colors.base.Text.PrimaryStatic,
                }}
              >
                {step.description}
              </Text>
            </div>
          </GridItem>
        ))}
      </Grid>
    </section>
  );
}

export default Steps;
